import { useCallback } from 'react'
import { useGetAdvancedMedicalReportLazyQuery } from './advancedMedicalReport.generated'

// no-cache: every click generates a new PDF behind a signed URL, so a cached result would be stale or expired.
export const useMedicalReport = (uid: string) => {
  const [getMedicalReport, { loading }] = useGetAdvancedMedicalReportLazyQuery({
    variables: { uid },
    fetchPolicy: 'no-cache',
  })

  const exportMedicalReport = useCallback(async () => {
    const { data, error } = await getMedicalReport()

    if (error) {
      throw error
    }

    const report = data?.patient?.medicalReport
    if (!report?.url) {
      throw new Error('Failed to generate medical report. Please try again.')
    }

    return { url: report.url, warning: report.warning ?? null }
  }, [getMedicalReport])

  return { exportMedicalReport, loading }
}
